import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div>
              <div className="text-2xl font-bold italic text-blue-400 mb-1" style={{ fontFamily: 'Arial, sans-serif' }}>
                InteCare
              </div>
              <div className="text-sm text-gray-400 italic mb-4">with Integrity and Care</div>
            </div>
            <div className="space-y-2">
              <div className="flex items-center">
                <i className="ri-phone-line mr-2 text-blue-400"></i>
                <a href="tel:+17147987318" className="hover:text-blue-400 transition-colors">
                  (714) 798-7318
                </a>
              </div>
              <div className="flex items-center">
                <i className="ri-mail-line mr-2 text-blue-400"></i>
                <a href="mailto:intecare.nemt@gmail.com" className="hover:text-blue-400 transition-colors">
                  intecare.nemt@gmail.com
                </a>
              </div>
              <div className="flex items-start">
                <i className="ri-map-pin-line mr-2 text-blue-400 mt-1"></i>
                <span className="text-gray-300">
                  8512 Westminster Blvd Ste B<br />
                  Westminster, CA 92683
                </span>
              </div>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Our Services</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/services/wheelchair" className="text-gray-300 hover:text-blue-400 transition-colors">
                  Wheelchair Transport
                </Link>
              </li>
              <li>
                <Link to="/services/ambulatory" className="text-gray-300 hover:text-blue-400 transition-colors">
                  Ambulatory Transport
                </Link>
              </li>
              <li>
                <Link to="/services/gurney" className="text-gray-300 hover:text-blue-400 transition-colors">
                  Gurney Transport
                </Link>
              </li>
              <li>
                <Link to="/services/hospital-discharge" className="text-gray-300 hover:text-blue-400 transition-colors">
                  Hospital Discharge
                </Link>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-blue-400 transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-300 hover:text-blue-400 transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-gray-300 hover:text-blue-400 transition-colors">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-blue-400 transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Social & Hours */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Connect With Us</h3>
            <div className="flex space-x-4 mb-6">
              <a href="#" className="text-gray-300 hover:text-blue-400 transition-colors">
                <i className="ri-facebook-fill text-2xl"></i>
              </a>
              <a href="#" className="text-gray-300 hover:text-blue-400 transition-colors">
                <i className="ri-instagram-line text-2xl"></i>
              </a>
            </div>
            <div>
              <h4 className="font-semibold mb-2">Service Hours</h4>
              <p className="text-gray-300 text-sm">
                24/7 non emergency transport services<br />
                Mon-Fri: 6:00 AM - 8:00 PM<br />
                Sat-Sun: 8:00 AM - 6:00 PM
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-gray-400 text-sm">
              <p>© 2026 InteCare Non-Emergency Medical Transportation. All rights reserved.</p>
              <p className="mt-1">HIPAA Compliant • Licensed & Insured</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
